<template>
    <div class="body">
        <mdb-card cascade>
            <mdb-view gradient="blue" cascade>
                <h2 class="card-header-title">Me contacter</h2>
            </mdb-view>
            <mdb-card-body class="text-center" cascade>
                <form id="form" @submit.prevent="submit">
                    <div class="grey-text">
                        <mdb-input label="Votre nom" icon="user" group type="text" validate error="wrong" id="your-name"
                                   name="your-name"
                                   success="right"/>
                        <mdb-input label="Votre email" icon="envelope" group type="email" validate error="wrong"
                                   id="your-email" name="your-email"
                                   success="right"/>
                        <mdb-input label="Sujet" icon="tag" group type="text" validate error="wrong" success="right"
                                   id="your-subject" name="your-subject"/>
                        <div class="md-form">
                            <i class="fas prefix fa-pencil"></i>
                            <textarea class="form-control md-textarea" placeholder="Votre message" name="your-message"
                                      id="your-message" cols="30" rows="2"></textarea>
                        </div>
                    </div>
                    <div class="text-center mt-4">
                        <button class="btn btn-outline-warning" type="submit">Envoyer<i
                                class="far fa-paper-plane ml-2"></i></button>
                    </div>
                </form>
                <hr/>
                <a class="px-2 icons-sm li-ic" href="https://www.linkedin.com/in/nathan-rousseau-602a30171/" target="_blank">
                    <mdb-icon fab icon="linkedin-in" size="lg"/>
                </a>
            </mdb-card-body>
        </mdb-card>
    </div>
</template>

<script>
    import axios from 'axios';
    import {mdbCard, mdbCardBody, mdbView, mdbIcon, mdbInput} from 'mdbvue';

    export default {
        name: "Contact",
        components: {
            mdbCard,
            mdbCardBody,
            mdbView,
            mdbIcon,
            mdbInput,
        },
        methods: {
            submit: function () {
                var form = document.getElementById('form');
                var formData = new FormData(form);
                axios.post('https://api.nathan-rousseau.fr/wp-json/contact-form-7/v1/contact-forms/5/feedback',
                    formData,)
                    .then(response => {
                        this.$fire({
                            title: "Candidature",
                            text: "Votre candidature à bien été envoyée",
                            type: "success",
                            timer: 3000
                        })
                        console.log(response.data)
                    }).catch(error => {
                    this.$fire({
                        title: "Candidature",
                        text: "Votre candidature n'a pas été envoyée, veuillez réesayer ultérieurement",
                        type: "warning",
                        timer: 3000
                    })
                    console.log(error.data)
                })
            }
        }
    }
</script>

<style scoped>
    a{
        color: #EAEAEA;
    }

    h2 {
        color: #EAEAEA;
    }

    .body {
        padding-top: 10vh;
        background-image: url("../assets/raw-min.webp");
        background-size: cover;
        background-position-x: 20%;
        padding-bottom: 1px;

    }

    .blue-gradient{
        background: #A52A2A !important;
        padding: 15px 20px;
    }

    .text-center{
        background-color: #363636;
    }

    .card {
        width: 80%;
        margin: 35% 10% 50% 10%;
    }

    .btn-outline-warning{
        color: #A52A2A !important;
        border: 2px solid #A52A2A !important;
    }


    @media (min-width: 576px) {

    }

    @media (min-width: 768px) {
        .card {
            width: 60%;
            margin: 35% 20% 50% 20%;
        }
    }

    @media (min-width: 992px) {
        .card {
            width: 40%;
            margin: 25% 30% 30% 30%;
        }
    }

    @media (min-width: 1200px) {

    }

    @media (min-width: 1600px) {
        .card {
            width: 30%;
            margin: 10% 35% 10% 35%;
        }
    }

</style>